import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useFunctionalTitles from '@hooks/useFunctionalTitles';

const buildFilterString = ({ member, functionalTitles }) => {
    const filterArray = ['NOT status:Inactive'];
    // const addressFilters = [];
    const companyFilters = [];
    const functionalTitleFilters = [];

    if (member.company?.primaryBusinessType) {
        companyFilters.push(`business_type:'${member.company.primaryBusinessType.name}'`);
    }

    if (member.company?.secondaryBusinessTypes?.length) {
        member.company.secondaryBusinessTypes.forEach(type => {
            companyFilters.push(`business_type:'${member.company.primaryBusinessType.name} > ${type.name}'`);
        });
    }

    // TODO: Remove once we get geolocation working. May need some form of this for chips though.
    // if (member.addresses?.length) {
    //     member.addresses.filter(address => address.purpose === 'main').forEach(address => {
    //         if (address.city && address.stateProvince) {
    //             addressFilters.push(`(location.city:${address.city} AND location.state:${address.stateProvince})`);
    //         }
    //         else if (address.city && address.stateProvince) {
    //             addressFilters.push(`location.city:${address.city} AND location.state:${address.stateProvince}`);
    //         } else if (address.country) {
    //             addressFilters.push(`location.country:${address.country}`);
    //         }
    //     });
    // }

    if (member.functionalTitle) {
        const title = functionalTitles.__type.enumValues.find(value => value.name === member.functionalTitle);

        if (title?.description) {
            functionalTitleFilters.push(`functional_title:'${title.description}'`);
        }
    }

    filterArray.push(
        `(${companyFilters.concat(functionalTitleFilters).join(' AND ')})`,
        member.recordId ? `NOT objectID:member-${member.recordId}` : ''
    );

    const filterStr = filterArray.filter(f => f).join(' AND ');
    return filterStr;
};

// member could be viewer
const useMembersLikeMeFilterString = ({ member, additionalFilters }) => {
    const [filterString, setFilterString] = useState();
    const { data: functionalTitles } = useFunctionalTitles();

    useEffect(() => {
        if (!member || !functionalTitles) {
            return;
        }

        const str = buildFilterString({ member, functionalTitles });
        setFilterString(str + (additionalFilters ? ` AND ${additionalFilters}` : ''));
    }, [additionalFilters, member, functionalTitles, filterString]);

    return { filterString };
};

useMembersLikeMeFilterString.propTypes = {
    member: PropTypes.object,
    additionalFilters: PropTypes.string,
};

export default useMembersLikeMeFilterString;
